import Fade from "@mui/material/Fade";
import LinearProgress from "@mui/material/LinearProgress";
import ImageDsCrm from "../../assets/preload/logo-crm.png";
import { useStyles } from "./styles";

type PreloadProps = {
  loading: boolean;
  children?: React.ReactElement<any, any>;
};

export function Preload({ loading, children }: PreloadProps) {
  const styles = useStyles();

  return loading ? (
    <Fade in>
      <div className={styles.root}>
        <img className={styles.logo} src={ImageDsCrm} alt="logo" />
        <LinearProgress className={styles.progress} />
      </div>
    </Fade>
  ) : (
    <Fade in>{children as React.ReactElement<any, any>}</Fade>
  );
}
